function salesStartDate() {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  return date;
}

// Non canceled orders counted in the store's trailing 12-month sales,
// which sales overage fees are based on (see order.submitted activities)
export function getOrderSalesQuery() {
  return {
    canceled: { $ne: true },
    draft: { $ne: true },
    test: { $ne: true },
    grand_total: { $gt: 0 },
    date_created: { $gt: salesStartDate().toISOString() },
  };
}

// Orders counted in sales which can be canceled, i.e. with no shipped items
export function getOrderCancelableQuery() {
  return {
    ...getOrderSalesQuery(),
    item_quantity_delivered: { $in: [0, null] },
  };
}

export function isOrderCountedInSales(order) {
  return Boolean(
    order &&
      !order.canceled &&
      !order.draft &&
      !order.test &&
      order.grand_total > 0 &&
      new Date(order.date_created) > salesStartDate(),
  );
}

// Order fields needed by isOrderCancelable
export const ORDER_CANCELABLE_FIELDS =
  'id,canceled,draft,test,grand_total,date_created,item_quantity_delivered';

export function isOrderCancelable(order) {
  return isOrderCountedInSales(order) && !(order.item_quantity_delivered > 0);
}
